import { FecAccountMappingSortKey } from '../enums/fecAccountMappingSortKey'
import { FecAccountMappingStatus } from '../enums/fecAccountMappingStatus'
import type { FecAccountMapping } from '../types/fecAccountMapping'

const STATUS_WEIGHTS: Record<FecAccountMappingStatus, number> = {
  [FecAccountMappingStatus.Existing]: 0,
  [FecAccountMappingStatus.New]: 1,
}

export interface FecAccountMappingSort {
  isDescending: boolean
  key: FecAccountMappingSortKey
}

export type FecAccountMappingSortDirection = 'ascending' | 'descending' | false

interface SortFecAccountMappingsParams {
  accountMappings: FecAccountMapping[]
  isDescending: boolean
  sortKey: FecAccountMappingSortKey
}

const compareAccountNo = (left: FecAccountMapping, right: FecAccountMapping): number =>
  left.accountNo.localeCompare(right.accountNo, undefined, { numeric: true })

export const sortFecAccountMappings = ({
  accountMappings,
  isDescending,
  sortKey,
}: SortFecAccountMappingsParams): FecAccountMapping[] => {
  const directionFactor = isDescending ? -1 : 1

  return [...accountMappings].sort((left, right) => {
    if (sortKey === FecAccountMappingSortKey.Status) {
      const statusComparison = STATUS_WEIGHTS[left.status] - STATUS_WEIGHTS[right.status]

      if (statusComparison !== 0) {
        return statusComparison * directionFactor
      }

      return compareAccountNo(left, right)
    }

    return compareAccountNo(left, right) * directionFactor
  })
}

export const toggleFecAccountMappingSort = (
  currentSort: FecAccountMappingSort,
  key: FecAccountMappingSortKey,
): FecAccountMappingSort => {
  if (currentSort.key === key) {
    return { ...currentSort, isDescending: !currentSort.isDescending }
  }

  return { isDescending: false, key }
}

export const getFecAccountMappingSortDirection = (
  sort: FecAccountMappingSort,
  key: FecAccountMappingSortKey,
): FecAccountMappingSortDirection => {
  if (sort.key !== key) {
    return false
  }

  if (sort.isDescending) {
    return 'descending'
  }

  return 'ascending'
}
